var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3582 10.0005H23.6503V10.0085C24.6019 9.99189 25.4663 10.5628 25.8273 11.4466C26.1883 12.3303 25.9722 13.3458 25.2828 14.0044L21.4843 17.8164C21.0615 18.2415 20.8189 18.8142 20.8074 19.4147V22.9311C20.8062 23.6602 20.4642 24.3466 19.8837 24.7851L18.8962 25.5284C18.1979 26.0616 17.2582 26.15 16.4733 25.7562C15.6885 25.3623 15.1951 24.5549 15.2012 23.6743V19.4147C15.1897 18.8142 14.9471 18.2415 14.5243 17.8164L10.7257 14.0044C10.0303 13.3468 9.81025 12.3274 10.1721 11.4399C10.5339 10.5525 11.403 9.98027 12.3582 10.0005ZM24.6856 11.8945C24.5137 11.4729 24.1043 11.1979 23.6503 11.1993H12.3582C11.9043 11.1979 11.4948 11.4729 11.323 11.8945C11.1456 12.3142 11.2437 12.8001 11.5699 13.1173L15.3843 16.9293C16.0446 17.5863 16.4146 18.4816 16.4116 19.4147V23.6743C16.4074 23.9689 16.5199 24.2532 16.7245 24.4645C16.9291 24.6758 17.209 24.7969 17.5026 24.8011C17.7425 24.8 17.9752 24.7185 18.1636 24.5694L19.151 23.8261C19.4318 23.6148 19.597 23.2832 19.597 22.9311V19.4147C19.5982 18.4793 19.9741 17.5837 20.6402 16.9293L24.4387 13.1173C24.7649 12.8001 24.863 12.3142 24.6856 11.8945Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.195c8063aa2539df1b5091369f3d29a6.svg";
export { ForwardRef as ReactComponent };